import { QueryClient } from '@tanstack/react-query';

import { appConfig } from '@/shared/config';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { ...appConfig.query },
  },
});
